import React, {useMemo, useState, useEffect} from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import AutocompleteEmail from '../autocomplete-email';
import {useSelector} from "react-redux";
import {getUsageReportRecipients} from "../../shared/api";
import {USER_SUPERADMIN} from "../../shared/constants";

const EmailReportModal = (props) => {

    const [recipientList, updateRecipientList] = useState([]);

    const ifwUserDataImmutable = useSelector((state) =>
        state.dataStore.getIn(["ifwUsers"])
    );

    const ifwEmailList = useMemo(() => {
        const dataSet = ifwUserDataImmutable.toJS();
        return dataSet
            .filter((item) => item.role === USER_SUPERADMIN)
            .map(item => {
                return item.email;
            });
    }, [ifwUserDataImmutable]);

    const token = useSelector((state) => state.dataStore.getIn(["loginInfo", "authorizationToken"]));

    const loadDefaultRecipientList = async () => {
        const recipients = await getUsageReportRecipients(token);
        updateRecipientList(recipients.userEmails !== null ? recipients.userEmails : []);
    };

    useEffect(() => {
        loadDefaultRecipientList();
    }, [props.open]);

    const handleCancel = () => {
        props.cancel();
    };

    const handleSendNow = () => {
        props.sendNow(recipientList);
    };

    const handleRecipientListUpdate = (event, newValue) => {
        updateRecipientList(newValue);
    }

    return (
        <Modal
            open={props.open}
            onClose={handleCancel}
            aria-labelledby="email-report-modal-title"
        >
            <Box sx={{width: '50%', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', position: 'absolute', bgcolor: 'background.paper', boxShadow: 24, p: 4}}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Typography variant="h1">Confirm the email recipients</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <AutocompleteEmail data={ifwEmailList} value={recipientList} onChange={handleRecipientListUpdate} />
                    </Grid>
                    <Grid item xs={12}>
                        <Button variant="contained" color="secondary" onClick={handleCancel}>
                            Cancel
                        </Button>
                        <Button disabled={recipientList === null || recipientList.length === 0} variant="contained" color="primary" onClick={handleSendNow}>
                            Send Now
                        </Button>
                    </Grid>
                </Grid>
            </Box>
        </Modal>
    );
};

export default EmailReportModal;
